module.exports = "<span class=\"label\" [ngClass]=\"'label-'+getStatusData(status, 'color')\">\n    {{getStatusData(status, 'name')}}\n</span>"


//////////////////
// WEBPACK FOOTER
// /Users/moe.dchater/personal/firebase-projects/hosting/src/app/projects/shared/status/status.component.html
// module id = ../../../../../src/app/projects/shared/status/status.component.html
// module chunks = main